import React from 'react'
import { Grid } from 'semantic-ui-react'
import InputField from '../../../commonComponents/formComponents/inputField'
import { useDispatch, useSelector } from 'react-redux'
import { TranslateContext } from '../TranslateContext'
import { AddDropdown } from '../../../commonComponents/dropdown/AddDropdown'
import UNDG from './undg'
import ArticalNumber from './articalNumber'
import validate from 'validate.js'
import * as ActionTypes from '../../actions/actionTypes'
import { createLineItemMsgStructure } from '../../util/itemsTabValidation'

const MerchForm7 = ({
  invoiceIndex,
  lineItemIndex,
  invoiceId,
  merchandiseId,
  saveData,
  updateData,
  isDMS,
  onChange,
  updateCalculatedValue,
  fieldPattern,
  validateError
}) => {
  const dispatch = useDispatch()
  const pkgQty =useSelector((state) => state.InvoicesReducer.lineItems[invoiceId][lineItemIndex]?.pkgQty) || ''
  const pkgType =useSelector((state) => state.InvoicesReducer.lineItems[invoiceId][lineItemIndex]?.pkgType) || ''
  const shippingMark =useSelector((state) => state.InvoicesReducer.lineItems[invoiceId][lineItemIndex]?.shippingMark) || ''
  const translate = React.useContext(TranslateContext).translate

  const {lineItem} = fieldPattern()?.items

  const shippingMarkErr = useSelector((state)=>state?.ValidationErrors.items?.[`invoice${invoiceIndex+1}_lineItem${lineItemIndex+1}_shippingMark`]) 
  const pkgQtyErr = useSelector((state)=>state?.ValidationErrors.items?.[`invoice${invoiceIndex+1}_lineItem${lineItemIndex+1}_pkgQty`]) 
  const pkgTypeErr = useSelector((state)=>state?.ValidationErrors.items?.[`invoice${invoiceIndex+1}_lineItem${lineItemIndex+1}_pkgType`]) 

  
  return (
    <Grid.Row>
      <Grid.Column width='4' className='divFormFeild b-bw-1 b-blr-5'>
      <AddDropdown
              id={`packageType-${invoiceId}-${merchandiseId}`}
              type='packageTypes'
              errors={pkgTypeErr && [pkgTypeErr?.msg]}
              label={translate('PKG_TYPE', { ns: ['default', 'lineItem'] })}
              onSelect={({ value }) => {
                updateData({pkgType:value})
                saveData({pkgType: value})

                const key1 = `invoice${invoiceIndex + 1}_lineItem${lineItemIndex + 1}_pkgType`
                  const key2 = `invoice${invoiceIndex + 1}_lineItem${lineItemIndex + 1}_shippingMark`
                  let lineItemErr = validate({ pkgType: value?.trim(), shippingMark: shippingMark },
                    { pkgType: lineItem()?.pkgType, shippingMark: lineItem()?.shippingMark }
                  ) || {}
                  lineItemErr = createLineItemMsgStructure(lineItemErr, invoiceIndex, lineItemIndex)
                  dispatch({
                    type: ActionTypes.UPDATE_VALIDATION_ERRORS,
                    tabName: 'items',
                    payload: { [key1]: "", [key2]: "", ...lineItemErr }
                  })
              }}
              onBlur={({ value }) => {
                if(!value?.trim()){
                  updateData({pkgType:value})
                  saveData({pkgType: value || " "})

                  const key1 = `invoice${invoiceIndex + 1}_lineItem${lineItemIndex + 1}_pkgType`
                  const key2 = `invoice${invoiceIndex + 1}_lineItem${lineItemIndex + 1}_shippingMark`
                  let lineItemErr = validate({ pkgType: value?.trim(), shippingMark: shippingMark },
                    { pkgType: lineItem()?.pkgType, shippingMark: lineItem()?.shippingMark }
                  ) || {}
                  lineItemErr = createLineItemMsgStructure(lineItemErr, invoiceIndex, lineItemIndex)
                  dispatch({
                    type: ActionTypes.UPDATE_VALIDATION_ERRORS,
                    tabName: 'items',
                    payload: { [key1]: "", [key2]: "", ...lineItemErr }
                  })

                }
              }}
              selectedValue={pkgType}
            />
            
       
      </Grid.Column>
      <Grid.Column width={isDMS ? '2' : '4'} className='divFormFeild  border-bottom b-rw-0 '>
        <InputField
          isLabel={false}
          id={`packages-${invoiceId}-${merchandiseId}`}
          type='number'
          label={`#${translate('PACKAGES', { ns: ['default', 'lineItem'] })}`}
          mandatory={false}
          value={pkgQty}
          errors={pkgQtyErr&&pkgQtyErr?.msg}
          className='field-bg'
          clearInput={false}
          onChange={(value) =>updateData({pkgQty:value})}
          onBlur={(value) =>{
            updateCalculatedValue({pkgQty: pkgQty || 0})
            const key = `invoice${invoiceIndex+1}_lineItem${lineItemIndex+1}_pkgQty`
            validateError({[key]:""},{[key]:value},
                  {[key]:lineItem(invoiceIndex+1, lineItemIndex+1)?.pkgQty}
            )
          }}
        />
      </Grid.Column>
      <Grid.Column width={isDMS ? '2' : '8'} className='divFormFeild b-bw-1 b-brr-5 '>
        <InputField
          isLabel={false}
          id={`shipMark-${invoiceId}-${merchandiseId}`}
          type='text'
          label={translate('SHIP_MARK', { ns: ['default', 'lineItem'] })}
          value={shippingMark}
          errors={shippingMarkErr&&shippingMarkErr?.msg}
          className={'field-bg'}
          clearInput={false}
          onChange={(value) =>updateData({shippingMark:value})}
          onBlur={(value) =>  {
            saveData({shippingMark: shippingMark || " "})
            // const key = `invoice${invoiceIndex+1}_lineItem${lineItemIndex+1}_shippingMark`
            // validateError({[key]:""},{[key]:value},
            //       {[key]:lineItem(invoiceIndex+1, lineItemIndex+1)?.shippingMark}
            // )

            const key1 = `invoice${invoiceIndex + 1}_lineItem${lineItemIndex + 1}_pkgType`
            const key2 = `invoice${invoiceIndex + 1}_lineItem${lineItemIndex + 1}_shippingMark`
            let lineItemErr = validate({ pkgType: pkgType, shippingMark: value?.trim() },
              { pkgType: lineItem()?.pkgType, shippingMark: lineItem()?.shippingMark }
            ) || {}
            lineItemErr = createLineItemMsgStructure(lineItemErr, invoiceIndex, lineItemIndex)
            dispatch({
              type: ActionTypes.UPDATE_VALIDATION_ERRORS,
              tabName: 'items',
              payload: { [key1]: "", [key2]: "", ...lineItemErr }
            })

          }}
        />
      </Grid.Column>
      {isDMS && (
        <React.Fragment>
          <Grid.Column width={4} className='divFormFeild  border-bottom b-rw-0 '>
          <UNDG boxNumber='6/12' lineItemIndex={lineItemIndex} invoiceId={invoiceId} updateData={updateData} onChange={onChange} />
          </Grid.Column>
          <Grid.Column width={4} className='divFormFeild  border-bottom'>        
            <ArticalNumber
              invoiceId={invoiceId}
              lineItemIndex={lineItemIndex}
              id={`artNumber-${invoiceId}-${merchandiseId}`}
              updateData={updateData}
              saveData={saveData}  
            />
           
          </Grid.Column>
        </React.Fragment>
      )}
    </Grid.Row>
  )
}
export default React.memo(MerchForm7)
